import { UUID } from '@hfc/common/src/types/UUID';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import { EnrollmentRepository } from '@/application/shared/domain/EnrollmentRepository';
import { UseCase } from '@/shared/application/UseCase';
import { SfApiResponse } from '@hfc/ui-core';
import { ChallengeType } from '@/application/shared/domain/ChallengeQuestionSettings';
import { OtpVerificationCodeRequest } from '@/shared/domain/OtpVerificationCodeRequest';

export class SendVerificationCodeUseCase implements UseCase<[APPLICATION_TYPES, ChallengeType, UUID, OtpVerificationCodeRequest], SfApiResponse<string>> {

  private repository: EnrollmentRepository;

  public constructor (repository: EnrollmentRepository) {
    this.repository = repository;
  }

  public async run (input: [APPLICATION_TYPES, ChallengeType, UUID, OtpVerificationCodeRequest]): Promise<SfApiResponse<string>> {
    const [type, challengeType, uuid, verificationCodeRequest] = input;

    return await this.repository.sendVerificationCode(type, challengeType, uuid, verificationCodeRequest);
  }

}
